import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ palette }) => ({
  status: {
    color: ({ enabled }) => enabled ? palette.success.main : palette.grey.main
  }
}))
